import { useCallback, useEffect, useState } from 'react';
import {
  fetchReservationSweepStatus,
  type ReservationSweepStatus,
} from '@/services/inventory';

// Carga el estado del barrido automático de reservas (cron): última corrida,
// intervalo y si está activo. Es informativo y no bloqueante.
export function useReservationSweepStatus() {
  const [status, setStatus] = useState<ReservationSweepStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    fetchReservationSweepStatus()
      .then((res) => {
        if (!cancelled) setStatus(res);
      })
      .catch(() => {
        if (!cancelled) setStatus(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => load(), [load]);

  return { status, loading, refetch: load };
}